import { root } from '~/app/root'

export
default
root.constructor
